import { render, staticRenderFns } from "./MemberFlow.vue?vue&type=template&id=827bc832&scoped=true&"
import script from "./MemberFlow.vue?vue&type=script&lang=js&"
export * from "./MemberFlow.vue?vue&type=script&lang=js&"
import style0 from "./MemberFlow.vue?vue&type=style&index=0&id=827bc832&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827bc832",
  null
  
)

export default component.exports